import './App.css';
import PortfolioPages from './pages/PortfolioPages';

function App() {
  return (
    <PortfolioPages />
  );
}

export default App;
